module.exports = __webpack_public_path__ + "img/about-CEO.88f386e5.jpg";